import React, { useState } from "react";
import Divider from "../../components/Divider";
import Form from "../../components/Form";
import IconButton from "../../components/IconButton";
import Input from "../../components/Input";
import Paper from "../../components/Paper";
import PropTypes from "prop-types";
import Icon from "../../components/Icon";
import { useForm } from "react-hook-form";
import { makeStyles } from "../../utils/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../../components/Button";
import ButtonGroup from "../../components/ButtonGroup";
import * as yup from "yup";
import { FORM } from "../../utils/constans";
import Loader from "../../components/Loader";
import { paths } from "../../routes";
import Typography from "../../components/Typography";
import useTheme from "../../hooks/useTheme";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((css) => ({
    iconButton: css`
        margin: 0 10px;
    `,
    paper: css`
        position: relative;
        overflow: hidden;
        max-width: 380px;
        padding: 40px;
        width: 100%;
    `,
    btnSubmit: css`
        padding: 10px 45px;
        margin-top: 20px;
    `,
    typography: css`
        line-height: 1.8em;
        margin-bottom: 30px;
    `,
}));

const schema = yup.object().shape({
    password: yup.string().required(FORM.FIELD_IS_REQUIRED).min(6, FORM.PASSWORD_TOO_SHORT).max(20),
    passwordConfirmation: yup.string().oneOf([yup.ref('password'), null], FORM.PASSWORD_MUST_BE_SAME),
});

const FormResetPassword = ({ loading, onSubmit }) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();

    const [newPasswordShow, setNewPasswordShow] = useState(false);
    const [repeatPasswordShow, setRepeatPasswordShow] = useState(false);

    const handleToggleNewPassword = () => setNewPasswordShow((prevState) => !prevState);
    const handleToggleReapetPassword = () => setRepeatPasswordShow((prevState) => !prevState);

    const { register, handleSubmit, errors } = useForm({
        resolver: yupResolver(schema),
    });

    return (
        <Paper customStyle={styles.paper}>
            <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                <Typography customStyle={styles.typography} color={theme.colors.purple} align="center" as="h2">
                    {t("Podaj nowe hasło")}.
                </Typography>
                <Input
                    endAdornment={
                        <>
                            <Divider orientation="vertical" offset={20} />
                            <IconButton onClick={handleToggleNewPassword} customStyle={styles.iconButton}>
                                <Icon name="eye" />
                            </IconButton>
                        </>
                    }
                    type={newPasswordShow ? "text" : "password"}
                    ref={register}
                    name="password"
                    label={t("Hasło")}
                    placeholder={t("Hasło")}
                    autoComplete="new-password"
                    error={!!errors.password}
                    errorText={errors.password?.message}
                />
                <Input
                    endAdornment={
                        <>
                            <Divider orientation="vertical" offset={20} />
                            <IconButton onClick={handleToggleReapetPassword} customStyle={styles.iconButton}>
                                <Icon name="eye" />
                            </IconButton>
                        </>
                    }
                    type={repeatPasswordShow ? "text" : "password"}
                    ref={register}
                    name="passwordConfirmation"
                    label={t("Powtórz hasło")}
                    placeholder={t("Powtórz hasło")}
                    autoComplete="new-password"
                    error={!!errors.passwordConfirmation}
                    errorText={errors.passwordConfirmation?.message}
                />
                <ButtonGroup direction="column">
                    <Button customStyle={styles.btnSubmit} type="submit" disabled={loading}>
                        {t("Resetuj hasło")}
                    </Button>
                    <Button customStyle={styles.btn} variant="text" to={paths.login}>
                        {t("Anuluj")}
                    </Button>
                </ButtonGroup>
            </Form>
            <Loader show={loading} />
        </Paper>
    );
};

FormResetPassword.propTypes = {
    loading: PropTypes.bool,
    onSubmit: PropTypes.func
};

export default FormResetPassword;